export interface ReviewBreakdown {
  stars: number;
  pct: number;
  count: number;
}

export const reviewSummary = {
  avg: "4.8",
  total: 124,
  breakdown: [
    { stars: 5, pct: 72, count: 89 },
    { stars: 4, pct: 18, count: 22 },
    { stars: 3, pct: 6, count: 8 },
    { stars: 2, pct: 2, count: 3 },
    { stars: 1, pct: 2, count: 2 },
  ] as ReviewBreakdown[],
};

export interface Review {
  id: number;
  name: string;
  date: string;
  rating: number;
  comment: string;
  service: string;
  order: string;
  replied: boolean;
  reply?: string;
}

export const reviews: Review[] = [
  {
    id: 1,
    name: "أحمد محمد",
    date: "16 أغسطس 2026",
    rating: 5,
    comment: "خدمة ممتازة وسريعة جداً، الموظف وصل في الوقت المحدد والشغل نظيف. أنصح فيهم بقوة.",
    service: "غسل خارجي وداخلي",
    order: "#GH-2845",
    replied: true,
    reply: "شكراً لك أحمد! يسعدنا خدمتك دائماً",
  },
  {
    id: 2,
    name: "جواهر العجمي",
    date: "15 أغسطس 2026",
    rating: 5,
    comment: "العاملات محترمات وشغل نظيف جداً، البيت صار يلمع. تجربة رائعة.",
    service: "تنظيف شامل",
    order: "#GH-2841",
    replied: false,
  },
  {
    id: 3,
    name: "هند المطيري",
    date: "15 أغسطس 2026",
    rating: 4,
    comment: "الغسيل ممتاز بس التوصيل تأخر شوي عن الموعد المحدد. غير كذا كل شي تمام.",
    service: "مغاسل ملابس",
    order: "#GH-2844",
    replied: true,
    reply: "شكراً لملاحظتك هند، بنحرص على تحسين مواعيد التوصيل",
  },
  {
    id: 4,
    name: "تركي الشهري",
    date: "14 أغسطس 2026",
    rating: 5,
    comment: "غسل السيارة كان ممتاز والمواد واضح إنها عالية الجودة. السيارة رجعت جديدة.",
    service: "غسل خارجي",
    order: "#GH-2843",
    replied: false,
  },
  {
    id: 5,
    name: "منى الدوسري",
    date: "13 أغسطس 2026",
    rating: 2,
    comment: "التنظيف ما كان بالمستوى المتوقع، في مناطق انتركبت من غير ما تتنظف. أتمنى الاهتمام أكثر بالتفاصيل.",
    service: "تنظيف شامل",
    order: "#GH-2836",
    replied: true,
    reply: "نعتذر عن التجربة منى، بنراجع الفريق ونعوضك في الطلب الجاي",
  },
  {
    id: 6,
    name: "بدر الرشيد",
    date: "12 أغسطس 2026",
    rating: 1,
    comment: "طلبت مغاسل واتلغى الطلب من غير إشعار مسبق. تجربة سيئة.",
    service: "مغاسل ملابس",
    order: "#GH-2839",
    replied: false,
  },
  {
    id: 7,
    name: "لمى الشمري",
    date: "11 أغسطس 2026",
    rating: 5,
    comment: "تلميع السيارة فاق التوقعات، النتيجة تستاهل كل ريال. شكراً!",
    service: "تلميع كامل",
    order: "#GH-2833",
    replied: false,
  },
];